import { graphql, useStaticQuery } from 'gatsby'

const SiteMetadata = () => {
  let data = useStaticQuery(
    graphql`
      {
        site: site {
          siteMetadata {
            title
            phone
            globalSchema
          }
        }

        pricing: mdx(fields: { isStartingPriceSource: { eq: true } }) {
          frontmatter {
            price
          }
        }
      }
    `
  )

  // Override startingPrice field
  data.site.siteMetadata['startingPrice'] = data.pricing.frontmatter.price

  return data.site.siteMetadata
}

export default SiteMetadata
